import React, { Fragment, useEffect, useState, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router'
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Breadcrumbs,
  Divider,
  MenuItem,
  Popper,
  Grow,
  Paper,
  ClickAwayListener,
  MenuList,
  Link,
  useMediaQuery,
  Stack,
  useTheme,
  Menu,
  Alert,
  Tooltip
} from '@mui/material'
import Logo from '../../generic/Logo'
import LogoManufacturing from '../../generic/LogoManufacturing'
import LogoGreenSmall from '../../generic/LogoGreenSmall'
import {
  ArrowDropDown,
  MenuRounded,
  Logout,
  PowerSettingsNew,
  Circle
} from '@mui/icons-material'
import ClockDisplay from '../../generic/ClockDisplay'
import { apiGet, apiPost, apiPut } from '../../generic/Api_Functions'

import Start from '../../../images/Start.svg'
import Stop from '../../../images/Stop.svg'
import TopBarBadge from './TopBarAlarms&Notifications'
import TopBarUser from './TopBarUser'
import CheckDialog from '../../generic/CheckDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { SmartDialog } from '../../generic/utilities/SmartDialog'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import { useUser } from '../../generic/hooks/useUser'
import { useAuthorization } from '../../generic/hooks/useAuthorization'
import { getCellGeneralStatus } from '../../generic/CellGeneralStatus'
import { useSmartInterval } from '../../generic/hooks/useSmartInterval'
import BackofficeMenuItem from '../../backoffice/BackofficeMenuItem'
import CameraControlMenuItem from '../../vision/cameraControl/CameraControlMenuItem'
import { canConfigureCameraControl } from '../../vision/cameraControl/cameraControlRules'
import AssistantLauncher from '../../assistant/AssistantLauncher'
import TranslatorButton from '../../translation/TranslatorButton'
import VisionChip from '../../vision/VisionChip'
import { selectableLanguages, languageLabel, STANDARD_LANGUAGES } from '../../generic/utilities/languageCatalogue'

const DescriptionTypography = (props) => (
  <Typography
    color={props.color}
    sx={{
      fontSize: 20,
      flexGrow: 3,
      paddingLeft: 1
    }}
  >
    {props.children}
  </Typography>
)

const DescriptionTitleTypography = (props) => (
  <Typography
    sx={{ fontSize: 20 }}
  >
    {props.children}
  </Typography>
)
const appBarStyle = {
  width: '100%',
  height: '84px',
  backgroundColor: theme => `${theme.palette.background.appBar} !important`,
  zIndex: theme => theme.zIndex.drawer + 1
}
const buttonStyle = {
  backgroundColor: '#222527 !important',
  marginRight: '0.25em !important',
  marginLeft: '0.25em !important',
  maxWidth: '52.5px !important',
  minWidth: '52.5px !important',
  height: '3.5em !important',
  border: ' 0.125em solid transparent !important',
  width: '200px'
}
const startActiveStyle = {
  color: '#80e0a7  !important',
  filter: 'drop-shadow(0px 0px 10px green)',
  border: '0.125em solid #05fd92  !important',
  backgroundColor: '#222527  !important',
  marginRight: '1em !important',
  marginLeft: '1em !important',
  maxWidth: '52.5px !important',
  minWidth: '52.5px !important',
  height: '3.5em !important'
}
const stopActiveStyle = {
  color: '#ff0707f2  !important',
  filter: 'drop-shadow(0px 0px 10px red)',
  border: '0.125em solid red  !important',
  backgroundColor: '#222527  !important',
  marginRight: '1em !important',
  marginLeft: '1em !important',
  maxWidth: '52.5px !important',
  minWidth: '52.5px !important',
  height: '3.5em !important'
}
const nodeActiveStyle = {
  color: '#FFFFFF  !important',
  filter: 'drop-shadow(0px 0px 3px white)',
  border: '0.125em solid #AAAAAA  !important',
  backgroundColor: '#222527  !important',
  marginRight: '1rem !important',
  marginLeft: '1rem !important',
  maxWidth: '50px !important',
  minWidth: '50px !important',
  height: '30px !important',
  fontSize: '1.1rem !important',
  fontWeight: 'bold !important'
}
const dividerStyle = {
  backgroundColor: '#818181  !important'
}

const buttonGroupStyle = {
  display: 'flex',
  justifyContent: 'center',
  width: '200px'
}
const buttonGroup2Style = {
  paddingLeft: '25px',
  paddingRight: '5px '
}
const iconStyle = {
  fontSize: '30px !important'
}

const languagesStyle = {
  fontSize: 15
}

const TopBar = (props) => {
  const [showLogoutDialog, setShowLogoutDialog] = useState({ open: false })
  const { changeHideMenu, hideMainMenuButton = false, reloadTopBar } = props
  const isUserAuthorized = useAuthorization()

  const [state, setState] = useState({
    checked: '',
    loaded: false
  })

  const handleLogoutDialog = () => {
    setShowLogoutDialog({ open: true })
  }

  // SETTINGS AND LANGUAGES
  const [open, setOpen] = useState(false)
  const [openLanguages, setOpenLanguages] = useState(false)
  const [openSettings, setOpenSettings] = useState(false)
  const anchorRefSettings = useRef(null)
  const anchorRefLanguages = useRef(null)
  const [serverMenuAnchor, setServerMenuAnchor] = useState(null)
  const serverMenuOpen = Boolean(serverMenuAnchor)
  const [selectedServerAction, setSelectedServerAction] = useState(null)
  const [staticConfig, setStaticConfig] = useState([])
  const { user, changeUserLanguage, userLogout } = useUser()
  const [showCheckDialog, setShowCheckDialog] = useState(false)
  const [serverActionResultOk, setServerActionResultOk] = useState(false)
  const [serverActionResultNOk, setServerActionResultNOk] = useState(false)
  const [nodes, setNodes] = useState([])
  const handleOpenSettings = () => {
    setOpenSettings((prevOpen) => !prevOpen)
    setOpen(false)
    setOpenLanguages(false)
  }
  const { t_, i18n } = useSmartTranslation()
  // Historia 138: el catálogo llega de quien ya lo leyó al abrir la sesión; los ocho de siempre son
  // el suelo, para que el selector nunca se quede sin opciones.
  const languageCatalogue = props.languageCatalogue || STANDARD_LANGUAGES
  // ⚠️ Esto es el código ELEGIDO, no el idioma activo. Con un personalizado que sustituye a su base
  // dejan de coincidir: el usuario tiene `es` guardado y la interfaz corre con `es-acme`. El selector
  // marca lo elegido.
  const [language, setLanguage] = useState(user?.userConfiguration?.languageCode || i18n.language)
  const handleOpenlanguages = () => {
    setOpenLanguages((prevOpen) => !prevOpen)
    setOpen(false)
    setOpenSettings(false)
  }
  const navigate = useNavigate()
  const theme = useTheme()

  function handleListKeyDown (event) {
    if (event.key === 'Tab') {
      event.preventDefault()
      setOpen(false)
    }
  }
  useEffect(() => {
    apiGet('frontEndConfig').then(setStaticConfig)
  }, [reloadTopBar])

  const fetchClusterStatus = async () => {
    return await apiGet('clusterState/status').then(data => {
      data?.sort((a, b) => a.name.localeCompare(b.name))
      return data
    })
  }

  useSmartInterval(fetchClusterStatus, 5000, setNodes)

  const isMobile = useMediaQuery(theme.breakpoints.only('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))
  const isSmall = useMediaQuery(theme.breakpoints.down('md'))
  const isLarge = useMediaQuery(theme.breakpoints.down('lg'))
  const isUpMd = useMediaQuery(theme.breakpoints.up('md'))
  const isDownLarge = useMediaQuery(theme.breakpoints.down('lg'))
  const isUpXLarge = useMediaQuery(theme.breakpoints.up('xl'))

  useEffect(() => {
    const interval = setInterval(() => {
      const currentStatus = getCellGeneralStatus()
      if (state.checked !== currentStatus) {
        setState({ ...state, loaded: true, checked: currentStatus })
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [state])

  // START AND STOP
  const handleChangeStart = (event) => {
    setShowCheckDialog(true)
  }

  const closeCheckDialog = (state) => {
    setShowCheckDialog(state)
  }

  const handleChangeStop = (event) => {
    const data = 'OFF'
    sendNewStatus(data)
    setShowCheckDialog(false)
  }

  const handleClickProfiles = () => {
    setOpenSettings(false)
    navigate('/profiles')
  }

  const handleClickUsers = () => {
    setOpenSettings(false)
    navigate('/users')
  }
  const handleClickSettings = () => {
    setOpenSettings(false)
    navigate('/settings')
  }

  const handleLogout = async () => {
    userLogout()
    setShowLogoutDialog({ ...showLogoutDialog, open: false })
  }

  async function sendNewStatus (data) {
    await apiPost('cellGeneralStatus', data)
    setState({ ...state, loaded: false, checked: data })
  }

  const playButtonSx = state.checked === 'AUTOMATIC' ? startActiveStyle : buttonStyle

  const stopButtonSx = state.checked === 'OFF' ? stopActiveStyle : buttonStyle

  const buttonImgStyle = (authorization) => {
    return !isUserAuthorized(authorization) ? 'grayscale(100%)' : 'none'
  }

  function SimpleBreadcrumbs () {
    const navigate = useNavigate()
    const location = useLocation()
    let currentRoutes = []

    currentRoutes = location.pathname !== '/' ? location.pathname.split('/') : []
    currentRoutes.shift()

    const handleNavigation = (index) => {
      const route = '/' + currentRoutes.slice(0, index + 1).join('/')
      navigate(route)
    }

    return (
      <Breadcrumbs aria-label='breadcrumb'>
        <Link color='inherit' onClick={() => navigate('/')} style={{ cursor: 'pointer', fontSize: '12px', color: '#818181' }}>
          mic
        </Link>
        {currentRoutes.map((route, index) => (
          <div key={index}>
            {index !== currentRoutes.length - 1
              ? (
                <Link
                  key={index}
                  color='inherit'
                  style={{ fontSize: '12px', cursor: 'pointer', color: '#818181' }}
                  onClick={() => handleNavigation(index)}
                >
                  {t_(route)}
                </Link>
                )
              : (
                <Typography key={index} color='inherit' style={{ fontSize: '12px' }}>
                  {t_(route)}
                </Typography>
                )}
          </div>
        ))}
      </Breadcrumbs>
    )
  }
  // App language is taken from the user, so after user language update in DB
  // The app will retrieve that data and store it in a contextProvider and localStorage
  useEffect(() => {
    if (user != null) {
      setLanguage(user.userConfiguration.languageCode)
    }
  }, [user])

  const changeLanguage = (language) => {
    updateUserLanguage(language)
    setOpenLanguages(false)
  }
  const updateUserLanguage = async (language) => {
    const newUser = changeUserLanguage(language)
    await apiPut('user/update/language', newUser)
  }
  // El idioma se aplica por el enganche de la historia 138, que resuelve qué diccionario toca, lo
  // registra y solo entonces lo aplica. Un `i18n.changeLanguage` pelado aquí se saltaría el
  // diccionario del cliente.
  const applyLanguage = props.applyLanguage
  useEffect(() => {
    if (applyLanguage) {
      applyLanguage(language)
      return
    }
    i18n.changeLanguage(language)
  }, [language, i18n, applyLanguage])

  const performServerAction = () => {
    return apiGet('server/' + selectedServerAction.toLowerCase())
  }

  const calculateColor = (currentNode, otherNodes) => {
    if (!currentNode) {
      return theme.palette.background.red
    }
    if (!currentNode?.digRepository && currentNode.connected) {
      return theme.palette.background.green
    }

    if (otherNodes && otherNodes.length > 0) {
      const allConnected = otherNodes ? otherNodes.every(s => s.connected) : false
      const allDisconnected = otherNodes ? otherNodes.every(s => !s.connected) : false
      if (allConnected) {
        return theme.palette.background.green
      } else if (allDisconnected) {
        return theme.palette.background.red
      } else {
        return theme.palette.background.orange
      }
    }

    return theme.palette.background.green
  }

  const getNodeTooltip = (otherNodes) => {
    if (!otherNodes || otherNodes.length === 0) return null

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {otherNodes.map((node, index) => (
          <div key={index} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Circle sx={{ color: calculateColor(node.connected, null), fontSize: 18 }} />
            <span>{node.name}</span>
          </div>
        ))}
      </div>
    )
  }

  const getNodeStatus = () => {
    if (!nodes || nodes.length === 0) {
      return <div style={{ width: '100px', display: 'inline-block' }} />
    }

    const currentNode = nodes?.find(node => node.current)
    const otherNodes = nodes.filter(node => !node.current)
    const color = calculateColor(currentNode, otherNodes)

    return (
      <>
        <Divider
          sx={dividerStyle}
          orientation='vertical'
          flexItem
        />
        <Tooltip
          arrow placement='left'
          disabled
          title={currentNode?.digRepository ? getNodeTooltip(otherNodes) : null}
        >
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '1rem', marginRight: '1rem' }}>
            <Button
              variant='contained' sx={nodeActiveStyle} onClick={() => {
                navigate('/cluster/pendingRequests')
              }}
            >DR
            </Button>
            {currentNode?.digRepository
              ? <Typography sx={{ textTransform: 'uppercase', mt: '0.5rem', color }}> {t_('Status')} </Typography>
              : <Typography sx={{ textTransform: 'uppercase', mt: '0.5rem', color }}> {currentNode?.connected ? t_('Connected') : t_('Disconnected')} </Typography>}
          </div>
        </Tooltip>
      </>
    )
  }

  return (
    <div>
      <SmartDialog
        title={{ icon: <Logout color='primary' sx={{ fontSize: '1.5rem' }} />, render: <Typography variant='h5'>{t_('Log out')}</Typography> }}
        message={t_('Are you sure you want to log out?')}
        cancel
        cancelCallback={() => setShowLogoutDialog({ ...showLogoutDialog, open: false })}
        accept
        acceptCallback={() => { handleLogout() }}
        setOpen={showLogoutDialog.open}
      />
      <SmartDialog
        title={{ icon: <PowerSettingsNew color='primary' sx={{ fontSize: '1.5rem' }} />, render: <Typography variant='h5'>{t_(selectedServerAction).toUpperCase()}</Typography> }}
        message={(
          <div style={{ marginTop: '1rem' }}>
            <Typography variant='body1'>{t_('ServerActionConfirmation', { serverAction: t_(selectedServerAction).toLowerCase() })}</Typography>
            <Typography variant='body2'>{t_('Connection with server may be lost')}</Typography>
            {serverActionResultOk && (
              <Alert sx={{ marginTop: '1rem' }} severity='success'>
                {t_('Server action was correctly performed')}
              </Alert>)}
            {serverActionResultNOk && (
              <Alert sx={{ marginTop: '1rem' }} severity='error' onClose={() => { setServerActionResultNOk(false) }}>
                {t_('Could not perform server action')}
              </Alert>)}
          </div>)}
        cancel
        cancelCallback={() => {
          setSelectedServerAction(null)
        }}
        accept
        acceptCallback={() => {
          performServerAction()
            .then(_ => {
              setServerActionResultOk(true)
              setTimeout(() => {
                setServerActionResultOk(false)
                setSelectedServerAction(null)
              }, 3000)
            })
            .catch(_ => setServerActionResultNOk(true))
        }}
        setOpen={selectedServerAction !== null}
      />
      <CheckDialog
        open={showCheckDialog}
        onClose={() => { closeCheckDialog(false) }}
        fixtureUse={staticConfig.fixtureUse}
      />

      <AppBar
        position='sticky'
        sx={appBarStyle}
      >
        <Toolbar>
          <div style={{ marginRight: '30px' }}>
            {isUpXLarge ? <Logo /> : <LogoGreenSmall />}
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '40%', height: '100%' }}>
            <Stack direction='column' justifyContent='center' sx={{ height: '100%', width: '50%' }}>
              <div style={{ height: '85%', paddingTop: '25px' }}>
                {isDownLarge ? null : <LogoManufacturing />}
              </div>
              <div>
                {isDownLarge ? null : <SimpleBreadcrumbs />}
              </div>
            </Stack>

            {isUpMd
              ? (
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <DescriptionTitleTypography>{t_('Site')}:</DescriptionTitleTypography>
                    <DescriptionTypography color='primary'>{staticConfig && staticConfig.site}</DescriptionTypography>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <DescriptionTitleTypography>{t_('Cell')}:</DescriptionTitleTypography>
                    <DescriptionTypography color='primary'>{staticConfig && staticConfig.cell}</DescriptionTypography>
                  </div>
                </div>
                )
              : null}
          </div>

          {getNodeStatus()}
          <Divider
            sx={dividerStyle}
            orientation='vertical'
            flexItem
          />

          <div style={isMobile ? buttonGroup2Style : buttonGroupStyle}>
            <Button
              variant='contained'
              sx={playButtonSx}
              onClick={handleChangeStart}
              disabled={!isUserAuthorized('CELL_START')}
            >
              <img height='75%' width='75%' src={Start} alt='start' style={{ filter: buttonImgStyle('CELL_START') }} />
            </Button>
            <Button
              variant='contained'
              sx={stopButtonSx}
              onClick={handleChangeStop}
              disabled={!isUserAuthorized('CELL_STOP')}
            >
              <img height='75%' width='75%' src={Stop} alt='stop' style={{ filter: buttonImgStyle('CELL_STOP') }} />
            </Button>
          </div>
          {
            !isMobile && !isTablet
              ? <Divider
                  sx={dividerStyle}
                  orientation='vertical'
                  flexItem
                />
              : null
          }
          <div>
            <Popper
              open={openSettings}
              anchorEl={anchorRefSettings.current}
              role={undefined}
              transition
              disablePortal
              placement='bottom-end'
            >
              {({ TransitionProps, placement }) => (
                <div>
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom'
                    }}
                  >
                    <Paper>
                      <ClickAwayListener
                        onClickAway={() => setOpenSettings(false)}
                      >
                        <MenuList
                          autoFocusItem={openSettings}
                          id='menu-list-grow'
                          onKeyDown={handleListKeyDown}
                        >
                          <MenuItem onClick={handleClickUsers} disabled={!isUserAuthorized('USERS')}>
                            {t_('Users')}
                          </MenuItem>
                          <Divider />
                          <MenuItem onClick={handleClickProfiles} disabled={!isUserAuthorized('PROFILES')}>
                            {t_('Profiles')}
                          </MenuItem>
                          <Divider />
                          <MenuItem onClick={handleClickSettings} disabled={!isUserAuthorized('SETTINGS')}>
                            {t_('Settings')}
                          </MenuItem>
                          <Divider />
                          <MenuItem onClick={e => setServerMenuAnchor(e.currentTarget)} disabled={!isUserAuthorized('SERVER_ACTION')}>
                            {t_('Server')}
                          </MenuItem>
                          <BackofficeMenuItem onClose={() => setOpenSettings(false)} />
                          <CameraControlMenuItem onClose={() => setOpenSettings(false)} />
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                </div>
              )}
            </Popper>
          </div>
          <Menu
            anchorEl={serverMenuAnchor}
            open={serverMenuOpen}
            onClose={_ => { setServerMenuAnchor(null) }}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            {
            ['Restart', 'Shutdown'].map(action => {
              return (
                <MenuItem
                  key={action}
                  onClick={_ => {
                    setServerMenuAnchor(null)
                    setSelectedServerAction(action)
                  }}
                >
                  {t_(action)}
                </MenuItem>
              )
            })
          }
          </Menu>
          {/* Story 213 (C11.3): the camera vigilance chip, before the bell; renders nothing with the vision off. */}
          <VisionChip />
          {
            !isMobile && !isTablet
              ? (
                <>
                  <TopBarBadge />
                  <Divider
                    sx={dividerStyle}
                    orientation='vertical'
                    flexItem
                  />
                </>
                )
              : null
          }
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '1em', justifyContent: 'space-between' }}>
            <TopBarUser
              style={{ color: 'red' }}
              open={open}
              setOpen={setOpen}
              openSettings={openSettings}
              setOpenSettings={setOpenSettings}
              setOpenLanguages={setOpenLanguages}
              handleListKeyDown={handleListKeyDown}
              handleLogout={handleLogoutDialog}
            />
            <AssistantLauncher />
            <div>
              <IconButton
                ref={anchorRefSettings}
                onClick={handleOpenSettings}
                sx={languagesStyle}
                // Story 213 (C14.3, DR-3): ADMIN and SUPERADMIN reach Camera control from here, also without MANAGEMENT.
                disabled={!isUserAuthorized('MANAGEMENT') && !canConfigureCameraControl(user)}
              >
                <ManageAccountsIcon />
              </IconButton>
            </div>

            {/* Free-text translator (story #119): sits next to the language selector. It renders
                nothing unless the global setting is ON and the service is healthy (RN1). */}
            <TranslatorButton translatorEnabled={staticConfig?.translatorEnabled === true} />

            <div>
              {!isSmall
                ? (
                  <Button
                    ref={anchorRefLanguages}
                    onClick={handleOpenlanguages}
                    sx={languagesStyle}
                    color='inherit'
                    disabled={!isUserAuthorized('LANGUAGES')}
                  >
                    {language.toUpperCase()} <ArrowDropDown sx={iconStyle} />
                  </Button>
                  )
                : null}
              <Popper
                open={openLanguages}
                anchorEl={anchorRefLanguages.current}
                role={undefined}
                transition
                disablePortal
                placement='bottom-end'
              >
                {({ TransitionProps, placement }) => (
                  <div>
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === 'bottom' ? 'center top' : 'center bottom'
                      }}
                    >
                      <Paper>
                        <ClickAwayListener
                          onClickAway={() => setOpenLanguages(false)}
                        >
                          <MenuList
                            autoFocusItem={openLanguages}
                            id='menu-list-grow'
                            onKeyDown={handleListKeyDown}
                          >
                            {selectableLanguages(languageCatalogue).map((option, index) => (
                              <Fragment key={option.code}>
                                {index > 0 ? <Divider /> : null}
                                <MenuItem
                                  onClick={() => { changeLanguage(option.code) }}
                                  selected={option.code === language}
                                >
                                  {languageLabel(option)}
                                </MenuItem>
                              </Fragment>
                            ))}
                          </MenuList>
                        </ClickAwayListener>
                      </Paper>
                    </Grow>
                  </div>
                )}
              </Popper>
            </div>
            <div>
              {!isLarge
                ? (
                  <>
                    <Divider
                      sx={dividerStyle}
                      orientation='vertical'
                      flexItem
                    />
                    <ClockDisplay />
                  </>
                  )
                : null}
            </div>
            {isSmall && !hideMainMenuButton
              ? (
                <IconButton
                  style={{ border: '1px solid #7FE1A7', color: '#7FE1A7' }}
                  aria-label='menu'
                  onClick={changeHideMenu}
                >
                  <MenuRounded />
                </IconButton>
                )
              : null}
          </div>
        </Toolbar>

      </AppBar>
    </div>
  )
}

export default TopBar
